import {UPDATE_USER} from '../../action.types'

export const updateUser = user => ({type: UPDATE_USER, payload: user})


// WEBPACK FOOTER //
// ./src/js/actions/user/user.actions.js